var map = {
	"./loan-buy.svg": 87158,
	"./loan-discount.svg": 37200,
	"./loan-lightning.svg": 74878,
	"./loan-paper.svg": 73041,
	"./loan-sawtooth-success.svg": 87619,
	"./loan-success.svg": 43893,
	"./loan-ticket.svg": 63777,
	"./loan-warehousing.svg": 54200,
	"./question.svg": 88622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40240;